export { default } from './JoinQrView';



// WEBPACK FOOTER //
// ./src/components/views/JoinQrView/index.js